import { styled } from '@ori-ui/mui';
import { isBeautyApp } from '@ori/beauty-app-info';
import { Breadcrumbs } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';

const Root = styled('div')`
  color: inherit;

  a:hover,
  a:focus {
    color: inherit;
  }
`;

const Component: FC = () => {
  const { getTestId } = useTestId();
  const { breadcrumbs } = useTopAreaStore();
  if (isBeautyApp() || !breadcrumbs.length) {
    return null;
  }

  return (
    <Root data-testid={getTestId('breadcrumbs')}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </Root>
  );
};
Component.displayName = 'Breadcrumbs';

export { Component as Breadcrumbs };
